<script>
	export let workmodes = {};
	export let title = "";
	let isHovered = false;
	let x;
	let y;
	
    const weekDays = [
        ['mon', 'Пн'],
        ['tue', 'Вт'],
        ['wed', 'Ср'],
        ['thu', 'Чт'],
        ['fri', 'Пт'],
        ['sat', 'Сб'],
        ['sun', 'Вс'],
    ];
	function mouseOver(event) {
		isHovered = true;
		x = event.pageX - 150;
		y = event.pageY + 10;
	}
	function mouseMove(event) {
		x = event.pageX - 150;
		y = event.pageY + 10;
	}
	function mouseLeave() {
		isHovered = false;
	}
    let schedule = [];
    for (let i = 0; i < 7; i++) {
        if(workmodes[weekDays[i][0]] && workmodes[weekDays[i][0]][0] != '' && workmodes[weekDays[i][0]][0] != workmodes[weekDays[i][0]][1]) {
            schedule.push([weekDays[i][1], 'c ' + workmodes[weekDays[i][0]][0] + ' до ' + workmodes[weekDays[i][0]][1]]);
        }else {
            schedule.push([weekDays[i][1], 'не работает']);
        }
    }
    if(workmodes['holyday'] && workmodes['holyday'][0]!=''){
        schedule.push(['Пр', 'c ' + workmodes['holyday'][0] + ' до ' + workmodes['holyday'][1]]);
    }
    let currentDay = new Date().getDay() - 1;
    if (currentDay === -1) {
        currentDay = 6;
    }

</script>
<div class="tooltip-container"
    on:mouseover={mouseOver}
    on:focus={mouseOver}
    on:mouseleave={mouseLeave}
    on:mousemove={mouseMove}>
    <slot />
</div>
{#if isHovered}
	<div style="top: {y}px; left: {x}px;" class="workmodes-tooltip">
        <div>{title}</div>
        <b>Время работы:</b>
        <ul class="workmodes">
        {#if workmodes.nonstop}
            <li class="today">Круглосуточно</li>
        {:else}
            {#each schedule as info, key}
                <li class={currentDay == key ? 'today' : ''}><b>{info[0]}</b>: {info[1]}</li>
            {/each}
        {/if}
        </ul>
    </div>
{/if}

<style>
	.workmodes-tooltip {
		border: 1px solid #ddd;
		box-shadow: 1px 1px 1px #ddd;
		background: rgba(255,255,255,0.8);
		border-radius: 4px;
        padding: 8px 21px;
        position: absolute;
        width: 300px;
        border-radius: 3px;
        display: inline-block;
        font-size: 13px;
        text-align: center;
	}
    .workmodes-tooltip::before{
        border-left: 10px solid transparent;
        border-right: 10px solid transparent;
        bottom: -8px;
        left: 50%;
        margin-left: -10px;
        content: "";
        width: 0;
        height: 0;
        position: absolute;
    }

    ul.workmodes b {
        display: inline-block;
        width: 18px;
    }

    ul.workmodes {
        list-style: none;
        margin: 0;
        padding: 0;
        text-align: left;
        width: 130px;
        margin: 0 auto;
    }

    ul.workmodes li {
        list-style: none;
        padding: 0px 3px;
    }

    ul.workmodes li.today {
        background-color: #8ba038;
        padding: 3px;
        border-radius: 2px;
        color: white;
    }

</style>